import React from "react";

function Project({ title, issuer, image, credentialLink }) {
  return (
    <div
      className="group bg-white dark:bg-gray-900 
                 border border-gray-200 dark:border-gray-700 
                 rounded-xl p-6 
                 transition-all duration-300
                 hover:-translate-y-2 hover:shadow-xl hover:shadow-purple-400/20"
    >
      <div className="flex flex-col items-center text-center">
        <img
          src={image}
          alt={title}
          className="h-24 object-contain mb-4"
        />

        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          {title}
        </h3>

        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          {issuer}
        </p>

        {credentialLink && (
          <a
            href={credentialLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-block text-sm font-medium
                       text-purple-600 hover:text-purple-700"
          >
            View Credential →
          </a>
        )}
      </div>
    </div>
  );
}

export default Project;
